import Vue from 'vue';
// import _ from 'lodash';
import {
    GET_SYSTEM_AUTH_TABLE_REQUEST,
    GET_SYSTEM_AUTH_TABLE_SUCCESS,
    GET_SYSTEM_AUTH_TABLE_FAILURE
} from '../mutationTypes';

const state = {
    loading: false,
    authList: [], // 权限编辑表
    recommendAuth: [], // 系统推荐权限
};

const mutations = {
    [GET_SYSTEM_AUTH_TABLE_REQUEST](state) {
        state.loading = true;
    },
    [GET_SYSTEM_AUTH_TABLE_SUCCESS](state, res) {
        state.loading = false;
        state.authList = res;
    },
    [GET_SYSTEM_AUTH_TABLE_FAILURE](state) {
        state.loading = false;
    },
};

export const actions = {
    async getSystemAuthTable({ commit }) {
        commit(GET_SYSTEM_AUTH_TABLE_REQUEST);
        const res = await Vue.$ajax.get('authList');

        if (!res.errorType) {
            commit(GET_SYSTEM_AUTH_TABLE_SUCCESS, res);
        } else {
            commit(GET_SYSTEM_AUTH_TABLE_FAILURE);
        }
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/authEdit.js